/* Sparkle & Space – cart coupons, offers sheet and gift note (cart page + cart drawer).
   Codes are applied with the Cart AJAX API (`discount` on /cart/update.js); Razorpay Magic Checkout
   picks up the cart's code. Config comes from window.ssCartConfig (snippets/cart-drawer.liquid). */
(function () {
  if (window.ssCartOffers) return;
  var cfg = window.ssCartConfig || {};
  var AUTO_KEY = 'ss-auto-code-done';

  function post(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function appliedCode(cart) {
    var d = (cart.discount_codes || []).filter(function (x) { return x.applicable; })[0];
    return d ? d.code : '';
  }
  function onCartPage() { return /^\/cart\/?$/.test(window.location.pathname); }
  function mark() { try { sessionStorage.setItem(AUTO_KEY, '1'); } catch (e) {} }
  function marked() { try { return !!sessionStorage.getItem(AUTO_KEY); } catch (e) { return false; } }

  // Re-render whatever shows the cart. The cart page reloads; the drawer swaps in fresh HTML and stays open.
  function refresh() {
    if (onCartPage()) { window.location.reload(); return Promise.resolve(); }
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
    return fetch(url.toString())
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parse = function (html) { return new DOMParser().parseFromString(html || '', 'text/html'); };
        var fresh = parse(s['cart-drawer']).querySelector('.drawer__inner');
        var cur = document.querySelector('#CartDrawer .drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        // Dawn hides the drawer's items and footer while cart-drawer has is-empty (set when the page loaded empty).
        var drawer = document.querySelector('cart-drawer');
        if (fresh && drawer) {
          var empty = !!fresh.querySelector('.drawer__inner-empty');
          drawer.classList.toggle('is-empty', empty);
          var items = drawer.querySelector('cart-drawer-items');
          if (items) items.classList.toggle('is-empty', empty);
        }
        var bubble = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        var cb = document.getElementById('cart-icon-bubble');
        if (bubble && cb) cb.innerHTML = bubble.innerHTML;
      })
      .catch(function () {});
  }

  function setBusy(scope, busy) {
    if (!scope) return;
    scope.setAttribute('aria-busy', busy ? 'true' : 'false');
    scope.querySelectorAll('button, input').forEach(function (el) { el.disabled = busy; });
  }

  // Code changes run one after another, so an automatic code can never overwrite one the shopper just picked.
  var queue = Promise.resolve();
  function apply(code, scope, silent) {
    var run = function () { return applyNow(code, scope, silent); };
    queue = queue.then(run, run);
    return queue;
  }

  // Apply a code (or '' to remove). A code that doesn't apply is taken off again and explained in plain words.
  function applyNow(code, scope, silent) {
    var msg = scope && scope.querySelector('[data-ss-coupon-msg]');
    if (msg) msg.textContent = '';
    setBusy(scope, true);
    return getCart().then(function (before) {
      var prev = appliedCode(before);
      return post({ discount: code }).then(function (after) {
        var up = (code || '').toUpperCase();
        var ok = !code || (after.discount_codes || []).some(function (d) { return d.code.toUpperCase() === up && d.applicable; });
        if (ok) return refresh().then(function () { return true; });
        return post({ discount: prev }).then(function () {
          setBusy(scope, false);
          if (msg && !silent) {
            var tip = cfg.auto && cfg.auto.toUpperCase() !== up ? ' Try ' + cfg.auto + '.' : '';
            msg.textContent = '“' + code + '” doesn’t work for this cart.' + tip;
          }
          return false;
        });
      });
    }).catch(function () {
      setBusy(scope, false);
      if (msg) msg.textContent = 'Something went wrong. Please try again.';
      return false;
    });
  }

  // Auto-apply the store's current offer once per visit, when the cart has items and no code yet.
  function maybeAuto() {
    if (!cfg.auto || marked()) return;
    var run = function () {
      if (marked()) return;
      return getCart().then(function (cart) {
        if (!cart.item_count) return;
        mark();
        if ((cart.discount_codes || []).length) return;
        return applyNow(cfg.auto, null, true);
      }).catch(function () {});
    };
    queue = queue.then(run, run);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ss-coupon]');
    if (!form) return;
    e.preventDefault();
    var scope = form.closest('[data-ss-offers]');
    var code = (form.querySelector('input').value || '').trim().toUpperCase();
    var msg = scope.querySelector('[data-ss-coupon-msg]');
    if (!code) { msg.textContent = 'Enter a coupon code first.'; return; }
    mark();
    apply(code, scope);
  });

  var noteTimer;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ss-apply], [data-ss-remove], [data-ss-sheet-open], [data-ss-sheet-close]');
    if (!t) return;
    var scope = t.closest('[data-ss-offers]');
    if (t.hasAttribute('data-ss-apply')) { mark(); apply(t.getAttribute('data-ss-apply'), scope); }
    else if (t.hasAttribute('data-ss-remove')) { mark(); apply('', scope); }
    else if (t.hasAttribute('data-ss-sheet-open')) { openSheet(true); }
    else if (t.hasAttribute('data-ss-sheet-close')) { openSheet(false); }
  });

  function openSheet(open) {
    var sheet = document.querySelector('#CartDrawer [data-ss-sheet]');
    if (!sheet) return;
    sheet.hidden = !open;
    if (open) { var c = sheet.querySelector('[data-ss-sheet-close]'); if (c) c.focus(); }
    else { var o = document.querySelector('#CartDrawer [data-ss-sheet-open]'); if (o) o.focus(); }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sheet = document.querySelector('#CartDrawer [data-ss-sheet]');
    if (sheet && !sheet.hidden) { e.stopPropagation(); openSheet(false); }
  }, true);

  // Gift note: saved as the cart note.
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-ss-gift-toggle]');
    if (!box) return;
    var wrap = box.closest('[data-ss-gift]');
    var note = wrap.querySelector('.ss-gift__note');
    note.hidden = !box.checked;
    if (box.checked) wrap.querySelector('textarea').focus();
    else { wrap.querySelector('textarea').value = ''; post({ note: '' }); }
  });
  document.addEventListener('input', function (e) {
    var ta = e.target.closest && e.target.closest('[data-ss-gift-note]');
    if (!ta) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post({ note: ta.value }); }, 600);
  });

  // Bulk discount: "Add 1 more" raises the line to the qualifying quantity.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ss-bulk-key]');
    if (!b || b.disabled) return;
    b.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-ss-bulk-key'), quantity: Number(b.getAttribute('data-ss-bulk-qty')) })
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { b.disabled = false; b.querySelector('span').textContent = res.description || res.message; return; }
        return refresh();
      })
      .catch(function () { b.disabled = false; });
  });

  // Cart page offers dropdown: folded on phones, always open on wider screens.
  var wide = window.matchMedia('(min-width: 750px)');
  function syncDrops() { document.querySelectorAll('[data-ss-drop]').forEach(function (d) { d.open = wide.matches; }); }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('[data-ss-drop] > summary');
    if (s && wide.matches) e.preventDefault();
  });
  if (wide.addEventListener) wide.addEventListener('change', syncDrops);
  // Dawn re-renders the cart footer after quantity changes, which brings the dropdown back folded.
  new MutationObserver(function (list) {
    if (list.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.querySelector && (n.matches('[data-ss-drop]') || n.querySelector('[data-ss-drop]')); }); })) syncDrops();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncDrops); else syncDrops();

  window.ssCartOffers = { apply: apply, refresh: refresh };
  // Dawn declares PUB_SUB_EVENTS with const, so it is a global but not a property of window.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(maybeAuto, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maybeAuto); else maybeAuto();
})();
